/**
 * Application-level error discriminators the API returns in the error envelope
 * (`error.error.errorCode`), independent of the HTTP status. Mirrors the API's
 * AuthErrorCode — admin only declares the codes it branches on. See
 * ADR-0002 / ADR-0122.
 */
export enum AuthErrorCode {
  /** Valid-but-stale token (HTTP 401): admin silently renews and replays. */
  TOKEN_OUTDATED = 'TOKEN_OUTDATED',
}
